import { api } from "../http/client";
export const fetchData = async (route, options = {}) => {
  try {
    const method = options.method?.toLowerCase() || "get";
    const headers = options.headers || {};
    const data = options.body || null; // for POST/PUT

    // When sending FormData, remove Content-Type so axios auto-sets
    // multipart/form-data with the correct boundary
    if (data instanceof FormData) {
      headers["Content-Type"] = undefined;
    }

    const response = await api.request({
      url: route,
      method,
      headers,
      data,
      params: options.params, // if you pass query params
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};
